import { bindSuggestions, searchContext } from '@theme/vspots-search-suggestions';
import { DialogOpenEvent, DialogCloseEvent } from '@theme/dialog';

class PredictiveSearchComponent extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.listeners = new AbortController();
    const { signal } = this.listeners;
    const form = this.querySelector('form');
    const input = this.querySelector('[ref="searchInput"]');
    const results = this.querySelector('[ref="predictiveSearchResults"]');
    const clear = this.querySelector('[ref="resetButton"]');
    const dialog = this.closest('dialog-component');
    this.controller = bindSuggestions({ root: this, form, input, results, onClose: () => dialog?.closeDialog() });
    input.addEventListener('input', () => { clear.hidden = !input.value; }, { signal });
    clear.addEventListener('click', () => {
      input.value = ''; clear.hidden = true; input.focus(); this.controller.refresh();
    }, { signal });
    dialog?.addEventListener(DialogOpenEvent.eventName, () => { input.focus(); this.controller.refresh(); }, { signal });
    dialog?.addEventListener(DialogCloseEvent.eventName, () => this.controller.close(), { signal });
    document.addEventListener('keydown', event => {
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') { event.preventDefault(); dialog?.toggleDialog(); }
    }, { signal });
    form.addEventListener('submit', event => {
      const city = searchContext().city;
      if (input.value.trim().length < 2) {
        event.preventDefault();
        const url = new URL('/collections/alle-deals', location.origin);
        if (city) url.searchParams.set('city', city);
        location.href = url.toString();
        return;
      }
      form.querySelector('[name="city"]').value = '';
    }, { signal });
  }
  disconnectedCallback() {
    this.controller?.destroy(); this.listeners?.abort(); this.controller = null;
  }
}
if (!customElements.get('predictive-search-component')) customElements.define('predictive-search-component', PredictiveSearchComponent);
